
import { useState } from 'react';

export interface FAQItem {
  id: number;
  category: string;
  question: string;
  answer: string;
}

interface FAQAccordionProps {
  items: FAQItem[];
}

const FAQAccordion = ({ items }: FAQAccordionProps) => {
  const [openId, setOpenId] = useState<number | null>(null);

  const toggle = (id: number) => {
    setOpenId(prev => (prev === id ? null : id));
  };

  if (items.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-20 text-center">
        <div className="w-16 h-16 flex items-center justify-center rounded-full bg-slate-100 mb-4">
          <i className="ri-search-line text-slate-400 text-2xl"></i>
        </div>
        <p className="text-slate-600 font-semibold text-base mb-1">Nenhum resultado encontrado</p>
        <p className="text-slate-400 text-sm">Tente pesquisar com outras palavras ou contacte-nos diretamente.</p>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {items.map((item) => {
        const isOpen = openId === item.id;
        return (
          <div
            key={item.id}
            className={`rounded-xl border transition-all duration-200 overflow-hidden ${
              isOpen ? 'border-slate-300 shadow-md' : 'border-slate-100 hover:border-slate-200 hover:shadow-sm'
            } bg-white`}
          >
            <button
              onClick={() => toggle(item.id)}
              className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left cursor-pointer group"
            >
              <div className="flex items-center gap-4">
                <div
                  className={`w-8 h-8 flex items-center justify-center rounded-full shrink-0 transition-colors ${
                    isOpen ? 'bg-slate-900 text-white' : 'bg-slate-100 text-slate-500 group-hover:bg-slate-200'
                  }`}
                >
                  <i className="ri-question-line text-sm"></i>
                </div>
                <span className={`text-sm font-semibold leading-snug ${isOpen ? 'text-slate-900' : 'text-slate-700'}`}>
                  {item.question}
                </span>
              </div>
              <div
                className={`w-7 h-7 flex items-center justify-center rounded-full shrink-0 transition-all ${
                  isOpen ? 'bg-slate-900 text-white rotate-180' : 'bg-slate-100 text-slate-400'
                }`}
              >
                <i className="ri-arrow-down-s-line text-base"></i>
              </div>
            </button>
            <div
              className={`transition-all duration-300 ease-in-out ${
                isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
              } overflow-hidden`}
            >
              <div className="px-6 pb-5 pl-18">
                <div className="ml-12 border-l-2 border-slate-100 pl-5">
                  <p className="text-slate-500 text-sm leading-relaxed">{item.answer}</p>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default FAQAccordion;
